import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BillInfo } from '@cms-max/medicare-api-sdk'
import classes from './PremiumBillCard.module.scss'

export interface PremiumBillCardCostsProps {
  bill: BillInfo
}

export const PremiumBillCardCosts: FC<PremiumBillCardCostsProps> = ({ bill }) => {
  const { t } = useTranslation('premiumsBills', { keyPrefix: 'billCard' })
  const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

  return (
    <div className={`${classes.premiumBillCardCosts} ds-u-padding--3`}>
      <dl>
        <div>
          <dt>{t('currentPartA')}</dt>
          <dd>{currencyFormat.format(bill.partA.currentAmount)}</dd>
        </div>
        <div>
          <dt>{t('partAPastDue')}</dt>
          <dd>{currencyFormat.format(bill.partA.pastDue)}</dd>
        </div>
        <div>
          <dt>{t('currentPartB')}</dt>
          <dd>{currencyFormat.format(bill.partB.currentAmount)}</dd>
        </div>
        <div>
          <dt>{t('partBPastDue')}</dt>
          <dd>{currencyFormat.format(bill.partB.pastDue)}</dd>
        </div>
        <div>
          <dt>{t('currentBIRMAA')}</dt>
          <dd>{currencyFormat.format(bill.partBIRMAA.currentAmount)}</dd>
        </div>
        <div>
          <dt>{t('partBIRMAAPastDue')}</dt>
          <dd>{currencyFormat.format(bill.partBIRMAA.pastDue)}</dd>
        </div>
        <div>
          <dt>{t('currentDIRMAA')}</dt>
          <dd>{currencyFormat.format(bill.partDIRMAA.currentAmount)}</dd>
        </div>
        <div>
          <dt>{t('partDIRMAAPastDue')}</dt>
          <dd>{currencyFormat.format(bill.partDIRMAA.pastDue)}</dd>
        </div>
        <div>
          <dt>{t('totalBill')}</dt>
          <dd>{currencyFormat.format(bill.total)}</dd>
        </div>
      </dl>
    </div>
  )
}
